export default __webpack_public_path__ + "static/media/reason_share.f44dd2de.svg";